import { Button, Collapse, CollapseProps, Empty, Pagination } from "antd";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import { ChevronDownIcon, ChevronUpIcon, PlusIcon } from "../../../assets/svg";
import { useDisclosure } from "../../../hooks/useDisclosure";
import { Popup, PopupTitle } from "../../atoms/Popup";
import { SectionLoader } from "../../atoms/SectionLoader/SectionLoader";
import { useGetNotes } from "./api";
import { CreateNoteForm } from "./CreateNoteForm";
import { Note } from "./Note";

const HEIGHT = "26rem";
const defaultPage = 1;
const pageSize = 5;

export const Notes = () => {
  const [currentPage, setCurrentPage] = useState(defaultPage);
  const { isOpen, onClose, onOpen } = useDisclosure();
  const { bookingDetails } = useSelector((state: any) => state.newBooking);

  const { notesData, isLoadingNotes } = useGetNotes({
    moduleId: bookingDetails?.leaseId,
    page: currentPage,
    perPage: pageSize,
  });

  const notes = notesData?.data ?? [];

  const createNoteButton = (
    <Button
      type="text"
      style={{ borderRadius: 6, width: "1.5rem", display: "grid", justifyContent: "center", alignItems: "center" }}
      onClick={onOpen}
    >
      <PlusIcon />
    </Button>
  );

  const renderExpandIcon: CollapseProps["expandIcon"] = ({ isActive }) => (
    <Button
      type="text"
      style={{ borderRadius: 6, width: "1.5rem", display: "grid", justifyContent: "center", alignItems: "center" }}
    >
      {isActive ? <ChevronUpIcon /> : <ChevronDownIcon />}
    </Button>
  );

  return (
    <>
      <Collapse
        className="ds-collapse"
        defaultActiveKey="notes"
        expandIconPosition="end"
        collapsible="icon"
        expandIcon={renderExpandIcon}
        style={{ backgroundColor: "white", maxWidth: "28.5rem" }}
      >
        <Collapse.Panel
          header={<span style={{ fontWeight: 700, color: "var(--blue-600)", fontSize: "1.125rem" }}>Notes</span>}
          key="notes"
          extra={createNoteButton}
        >
          <div style={{ minHeight: HEIGHT }}>
            <SectionLoader isLoading={isLoadingNotes} containerStyle={{ height: HEIGHT }}>
              {notes.length > 0 ? (
                notes.map((item, index) => (
                  <div key={item.noteId}>
                    <Note data={item} />
                    {index < pageSize - 1 && <div style={{ borderBottom: "1px solid #d9d9d9" }} />}
                  </div>
                ))
              ) : (
                <Empty style={{ height: HEIGHT, display: "flex", flexDirection: "column", justifyContent: "center" }} />
              )}
            </SectionLoader>
          </div>

          {notesData?.pageCount > 1 && (
            <Pagination
              style={{ padding: "1.5rem", borderTop: "1px solid #d9d9d9", textAlign: "center", width: "100%" }}
              current={currentPage}
              total={notesData?.totalCount ?? 0}
              pageSize={pageSize}
              onChange={(page) => setCurrentPage(page)}
            />
          )}
        </Collapse.Panel>
      </Collapse>
      <Popup
        destroyOnClose
        visibility={isOpen}
        onCancel={onClose}
        style={{ padding: 10 }}
        title={<PopupTitle title="Create Note" />}
        content={<CreateNoteForm onClose={onClose} />}
      />
    </>
  );
};
